
<script>
  import {
    EventBus
  } from '../../event-bus';
  import startCase from "lodash/startCase";
  import axios from 'axios'
  import moment from "moment";
  import { mapGetters } from 'vuex'
  moment.locale('id');
  export default {
    components: {
      AddOnsTable: () => import("@/views/AddOns/AddOnsTable")
    },
    data: () => {
      return {
        errors: [],
        validasiNotelp: null,
        dataProfile: [],
        inChange: false,
        nohpBefore: null,
        btnDisable: true,
        imageProps: {
          width: 75,
          height: 75
        },
        provinces: [],
        checkValueNik: null,
        cities: [],
        provinces: [],
        image: null,
        tempat: {
          provinsi: null,
          kota: null,
        },
        prefillImage: null,
        addActive : null,
        dataAddOn : {
          "success": "true",
          "message": "",
          "data": {
            "is_active": true,
            "sms_terkirim": 10,
            "wa_terkirim": 5,
            "ultah_sms_terkirim": 10,
            "ultah_wa_terkirim": 5,
            "sisa_kuota_sms": 230,
            "sisa_kuota_wa": 190,
            "ultah_channels": [
              "wa",
              "sms"
            ],
            "ultah_channel_active": "wa"
          }
        }
      }
    },
    beforeRouteLeave(to, from, next) {

      if(to.name == "login-page"){
        this.$router.go('/login');
      }

      if (!this.beingSubmit && localStorage.getItem('IDLE') != 1) {

        if (this.btnDisable == false && this.dataProfile.klinik.alamat == null || this.dataProfile.klinik.alamat == '' ) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib terisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        } else {
          next();
        }

        if (this.btnDisable == false && !this.tempat.provinsi && !this.tempat.kota) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib terisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        } else {
          next();
        }

        if (this.btnDisable == false && this.tempat.provinsi && !this.tempat.kota) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib terisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        } else {
          next();
        }

      } else {
        next();
      }
    },
    mounted() {
      this.getProvince();
      this.checkAddons();
      this.getProfile();
      this.cekPaketNolock();
    },
    computed: {
      ...mapGetters(["getKlinikId"]),
    },
    watch: {
      dataProfile: {
        handler: function (val) {
          if (val) {
            this.fetchImg()
          }
        },
        deep: true
      }
    },
    methods: {
      fetchImg() {
        fetch(this.dataProfile.foto_profile)
          .then(response => response.blob())
          .then(images => {
            const x = URL.createObjectURL(images)
            this.prefillImage = x
          })
      },
      cekValueNotelp(ceknotelp) {
        if (ceknotelp.length < 15 && ceknotelp.length > 8) {
          this.inChange = true;
          if (this.timeVerifyPhone) clearTimeout(this.timeVerifyPhone)
          return new Promise((resolve, reject) => {
            this.timeVerifyPhone = setTimeout(() => {
              axios.get(`${this.url_api}/phone/verify?nomor_telp=${ceknotelp}`)
                .then(res => {
                  const {
                    data: {
                      status,
                      message
                    }
                  } = res;
                  this.validasiNotelp = res.data.message
                  resolve(status);
                })
                .catch(err => {

                }, )
              resolve(true);
            });
          }, 5000);
        }
      },
      async checkAddons() {
        try {
          const res = await axios.get(
            `${this.url_api}/patient-engagement`
          );
          this.addActive = res.data;
        } catch (err) {
          // console.log(err);
        }
      },
      async getProfile() {
        try {
          var profile = this.$store.state.user.id
          const res = await axios.get(`${this.url_api}/user/${profile}?klinik_id=${this.getKlinikId}`)
          this.dataProfile = res.data.data;
          this.nohpBefore = this.dataProfile.nomor_telp

          this.provinces.forEach(prov => {
            if (prov.id == this.dataProfile.klinik.provinsi) {
              this.tempat.provinsi = {
                ...prov,
                label: prov.provinsi_nama
              }
            }
          });

          if (this.tempat.provinsi && this.tempat.provinsi.id) {
            this.getCity();
          }
        } catch (e) {

        }
      },
      onChangeImage(image) {
        if (image) {
          let profile = this.$store.state.user.id;
          let formData = new FormData();
          formData.set('foto_profile', this.$refs.pictureInput.file);

          axios.post(`${this.url_api}/user/upload-foto/${profile}`, formData, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(() => {
            EventBus.$emit('image-uploaded', true);
          });
        }
      },
      disabledForm() {
        return this.formType === "detail";
      },
      async updateProses() {
        this.errors = [];

        if (!this.dataProfile.nama || !this.dataProfile.nomor_telp) {
          this.errors.push("Nama Dokter harus diisi!");
          this.$swal({
            title: "Gagal",
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "warning",
            confirmButtonText: startCase("ya")
          });
          return;
        }
        if (this.dataProfile.nomor_telp.length < 10 || this.dataProfile.nomor_telp.length > 15) {
          this.errors.push("Nama Dokter harus diisi!");
          this.$swal({
            title: "Gagal",
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "warning",
            confirmButtonText: startCase("ya")
          });
          return;
        }
        if (this.validasiNotelp === 'phone is already in use!' && this.dataProfile.nomor_telp !== this.nohpBefore) {
          this.errors.push("Nama Dokter harus diisi!");
          this.$swal({
            title: "Gagal",
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "warning",
            confirmButtonText: startCase("ya")
          });
          return;
        }
        if (this.dataProfile.klinik.alamat == null || this.dataProfile.klinik.alamat == '' ) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        }
        if (!this.tempat.provinsi && !this.tempat.kota) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        }
        if (this.tempat.provinsi && !this.tempat.kota) {
          this.$swal({
            text: `Silakan lengkapi kolom yang wajib diisi!`,
            type: "error",
            showCancelButton: false,
            confirmButtonText: startCase("OK")
          });
          return;
        }
        try {
          var profile = this.$store.state.user.id;
          const res = await axios.put(`${this.url_api}/user/${profile}?klinik_id=${this.getKlinikId}`, {
            nama: this.dataProfile.nama,
            nomor_telp: this.dataProfile.nomor_telp,
            jenis_kelamin: this.dataProfile.jenis_kelamin,
            nomor_ijin: this.dataProfile.klinik.nomor_ijin,
            provinsi: this.tempat.provinsi && this.tempat.provinsi.id ? this.tempat.provinsi.id : null,
            kota: this.tempat.kota && this.tempat.kota.id ? this.tempat.kota.id : null,
            alamat: this.dataProfile.klinik.alamat,
          })
          if (res.data.status) {
            this.inChange === false

            this.$swal({
              type: "success",
              title: startCase("Simpan Profil"),
              text: startCase("Simpan Profil berhasil."),
            });

            this.$nextTick(() => {
              this.$router.push(`/profile`);
            });


          } else {
            this.$swal({
              title: "Gagal",
              text: `Silakan lengkapi seluruh kolom!`,
              type: "error",
              confirmButtonText: startCase("ya")
            });
          }
          this.btnDisable = true;
        } catch {

        }
      },
      setDataTempat() {
        this.dataProfile.klinik['provinsi'] = this.tempat.provinsi && this.tempat.provinsi.id ? this.tempat.provinsi
          .id : null
        this.dataProfile.klinik['kota'] = this.tempat.kota && this.tempat.kota.id ? this.tempat.kota.id : null
      },
      getProvince() {
        axios.get(`${this.url_api}/province`)
          .then((response) => {
            // handle success
            this.provinces = response.data.data.provinsi.map(val => ({
              ...val,
              label: `${val.provinsi_nama}`,
            }));
          })
          .catch((error) => {
            // handle error
            // console.log(error);
          })
      },
      async getCity() {
        try {
          var val;
          this.tempat.kota = null;
          if (!this.tempat.provinsi || !this.tempat.provinsi.id) {
            val = '';
          } else {
            val = this.tempat.provinsi.id;
            const res = await axios.get(`${this.url_api}/getcitybyprovince/${val}`)
            // handle success
            this.cities = res.data.data.kota.map(val => ({
              ...val,
              label: `${val.nama}`,
            }));

            if (this.dataProfile.klinik.kota) {
              this.cities.forEach(city => {
                if (city.id == this.dataProfile.klinik.kota) {
                  this.tempat.kota = city;
                }
              });
            }
          }
        } catch (error) {
          // console.error(error);
        }
      },
      dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n) {
          u8arr[n] = bstr.charCodeAt(n)
          n -= 1 // to make eslint happy
        }
        return new File([u8arr], filename, {
          type: mime
        })
      }
    }
  }
</script>
